import React from "react";
import Page from "components/Page";
import { Props } from "./Account";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const Account = lazyWithRetry(() => import("./Account"));

export default (props: Props) => (
  <Page>
    <Account {...props} />
  </Page>
);
